import type { ApexOptions } from 'apexcharts'
import type { SongsTimeSeriesData } from '../../../features/engagement/domain/models/songs'
import { buildLineChartOptions, EngagementChartColors, longDateFormatter, type ChartSeriesItem } from '../charts'

export interface SongsLegendState {
  [key: string]: boolean
  timesPlayed: boolean
  uniqueListeners: boolean
}

export interface SongsLegendItem {
  key: string
  label: string
  color: string
}

export const SONGS_LEGEND_ITEMS: SongsLegendItem[] = [
  { key: 'timesPlayed', label: 'Songs: Total Times Played', color: EngagementChartColors.primary },
  { key: 'uniqueListeners', label: 'Songs: Unique Listeners', color: EngagementChartColors.secondary }
]

export const SONGS_INITIAL_LEGEND_STATE: SongsLegendState = {
  timesPlayed: true,
  uniqueListeners: true
}

export const getSongsChartOptions = (data: SongsTimeSeriesData[], legend: SongsLegendState): ApexOptions => {
  const categories = data.map((d) => d.date)

  const series: ChartSeriesItem[] = []

  if (legend.timesPlayed) {
    series.push({
      name: 'Songs: Total Times Played',
      data: data.map((d) => d.timesPlayed),
      color: EngagementChartColors.primary
    })
  }

  if (legend.uniqueListeners) {
    series.push({
      name: 'Songs: Unique Listeners',
      data: data.map((d) => d.uniqueListeners),
      color: EngagementChartColors.secondary
    })
  }

  return buildLineChartOptions({
    series,
    categories,
    tooltipHeaderFormatter: longDateFormatter
  })
}
